import React from "react";
import { GOOGLE_PLAY_URL } from "@/content/siteConfig";

type GooglePlayBadgeProps = {
  className?: string;
  "data-testid"?: string;
};

export const GooglePlayBadge: React.FC<GooglePlayBadgeProps> = ({ className = "", ...rest }) => (
  <a
    href={GOOGLE_PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center transition-transform duration-200 ease-out hover:-translate-y-0.5 ${className}`}
    {...rest}
  >
    <img src="/brand/google-play-badge.svg" alt="Get it on Google Play" className="h-full w-auto" />
  </a>
);
